export const ANIMATED_HEADER_SIZE = 72;
export const HEADER_SCROLL_REQUIREMENT = 1.5;
export const ICON_SIZE = 40;
